import { reverseGradeTranslation } from "../SchoolAdmin/translations";
import { BENCHMARK_ITEMS } from "../../const/BenchmarkItems";

/** @deprecated Use getBenchmarkItems(grade, subject)[0]?.label — kept for older imports. */
export const FLUENCY_LABEL = BENCHMARK_ITEMS[0]?.label || "Reading Fluency";

export const toStableGradeLevel = (raw) => {
    if (raw == null || raw === "") return null;
    const token = String(raw).trim();
    if (reverseGradeTranslation[token]) return reverseGradeTranslation[token];
    const upper = token.toUpperCase();
    if (Object.values(reverseGradeTranslation).includes(upper)) return upper;
    if (Object.keys(reverseGradeTranslation).includes(token)) return token;

    // Preview / admin payloads sometimes use bare numbers ("1") or "Grade 1".
    const numeric = token.match(/^(?:GRADE\s*)?(\d+)$/i);
    if (numeric) {
        const n = Number(numeric[1]);
        const byNumber = ["K", "FIRST", "SECOND", "THIRD", "FOURTH", "FIFTH", "SIXTH", "SEVENTH", "EIGHTH"];
        return byNumber[n] || null;
    }
    return null;
};

const subjectMatches = (item, subjectName) => {
    const key = String(subjectName || "")
        .trim()
        .toUpperCase();
    if (!key) return false;
    const names = [item.subject, ...(item.subjectAliases || [])].map((name) => String(name).trim().toUpperCase());
    return names.includes(key);
};

/** Items configured for this grade × subject. Empty → hide the fluency fields. */
export const getBenchmarkItems = (gradeName, subjectName) => {
    const grade = toStableGradeLevel(gradeName);
    if (!grade) return [];
    return BENCHMARK_ITEMS.filter((item) => subjectMatches(item, subjectName) && item.grades?.[grade]?.stem);
};

/**
 * Resolve which grade drives fluency catalog + stem.
 * Prefer the student's / selected shared grade over the teacher's EPR grade so
 * cross-grade shares (e.g. 2nd teacher + 1st students) show the correct benchmark.
 */
export const resolveFluencyGradeName = ({ studentGradeName, selectedGrade, sharedGradeName, eprGradeName } = {}) =>
    studentGradeName || selectedGrade || sharedGradeName || eprGradeName || null;

export const isFluencyEligible = (gradeName, subjectName) => getBenchmarkItems(gradeName, subjectName).length > 0;

export const getItemStem = (item, gradeName) => {
    const grade = toStableGradeLevel(gradeName);
    return item?.grades?.[grade]?.stem || null;
};

export const fluencyStem = (gradeName, subjectName = "ELA") => {
    const [item] = getBenchmarkItems(gradeName, subjectName);
    return item ? getItemStem(item, gradeName) : null;
};

export const fluencyParentSentence = (item, gradeName, value) => {
    const stem = getItemStem(item, gradeName);
    const trimmed = String(value ?? "").trim();
    if (!stem || !trimmed) return null;
    const tail = typeof item.parentValue === "function" ? item.parentValue(trimmed) : trimmed;
    return `${stem} ${tail}`;
};

export const sanitizeBenchmarkValue = (item, raw) => {
    const text = String(raw ?? "");
    if (item?.digitsOnly) return text.replace(/\D/g, "").slice(0, item.maxLength || 3);
    return text.slice(0, item?.maxLength || 40);
};

/** @deprecated Use sanitizeBenchmarkValue */
export const sanitizeWpm = (raw) => sanitizeBenchmarkValue({ digitsOnly: true, maxLength: 3 }, raw);
